import React, {useState, useEffect} from 'react'
import './SettingPanel.css'

const SettingsPanel = (props) => {
    const [first, setFirst] = useState(true);

    const sizes = [3, 4, 5, 6, 7, 8, 9];

    let bestTime = localStorage.getItem("bestTime" + props.size);
    let gamesPlayed = localStorage.getItem("gamesPlayed" + props.size);
    if (!bestTime) bestTime = "-";
    if (!gamesPlayed) gamesPlayed = 0;


    useEffect(() => {
        if (props.show && first) setFirst(false); 
    }, [props.show, first])

    return (
        <div className={props.show ? "settings-panel-container settings-panel-container-show" : 
                                first ? "settings-panel-container" : "settings-panel-container settings-panel-container-exit"}>
            <div className="grid-size">
                <p className="title" >Grid Size</p>
                {sizes.map((size) => {
                    let clsName = "size";
                    if (parseInt(props.size) === size) clsName += " active"
                    return <button className={clsName} key={size} onClick={() => props.sizeChanged(size)}>{size + "x" + size}</button>
                })}
            </div>
            <svg width="16" height="20" viewBox="0 0 16 20">
                <path d="M7.29289 19.7071C7.68342 20.0976 8.31658 20.0976 8.7071 19.7071L15.0711 13.3431C15.4616 12.9526 15.4616 12.3195 15.0711 11.9289C14.6805 11.5384 14.0474 11.5384 13.6569 11.9289L8 17.5858L2.34314 11.9289C1.95262 11.5384 1.31946 11.5384 0.928931 11.9289C0.538407 12.3195 0.538407 12.9526 0.928931 13.3431L7.29289 19.7071ZM7 -1.01226e-07L7 19L9 19L9 1.01226e-07L7 -1.01226e-07Z" fill="black" />
            </svg>


            <div className="stats">
                <p className="title">Best Time</p>
                <p className="value">{bestTime === '-' ? bestTime : (bestTime / 100).toFixed(2) + "s"}</p>
                <p className="title">Games</p>
                <p className="value">{gamesPlayed}</p>
            </div>
        </div>
    )
}

export default SettingsPanel
